<div fxLayout="row" fxLayoutGap="16px">
  <mat-icon *ngIf="icon">{{ icon }}</mat-icon>
  <mat-slide-toggle
    color="accent"
    [formControl]="control"
    [labelPosition]="labelPosition"
    (change)="onChange($event)"
    [checked]="isChecked"
  >
    {{ label }}
  </mat-slide-toggle>
</div>
<mat-error><wai-form-error [formField]="control"></wai-form-error></mat-error>
